module.exports = __webpack_public_path__ + "static/media/AmpleParking.e30b981c.png";